import gql from 'graphql-tag';

const queries = {
  generalQueries: gql`
     query feedbackType { 
       feedbackType {
          total_audios
          total_texts
          total_drawings,
          total_common_mistakes
       }
     }
    `,
}

export default queries;